/**
 * Simple hash function to convert a string to a number
 * Uses FNV-1a algorithm for good distribution
 */
function hashString(str: string): number {
  let hash = 2166136261 // FNV offset basis
  for (let i = 0; i < str.length; i++) {
    hash ^= str.charCodeAt(i)
    hash = (hash * 16777619) >>> 0 // FNV prime, ensure unsigned
  }
  return hash
}

/**
 * Generate a seeded random number between 0 and 1
 * Same seed always produces same result
 */
export function seededRandom(seed: string): number {
  const hash = hashString(seed)
  // Normalize to 0-1 range
  return (hash % 1000000) / 1000000
}

/**
 * Select a tarot card deterministically based on user info
 * Same user always gets the same card for the same year
 */
export function selectTarotCard(
  userId: number | null,
  name: string,
  year: number
): { cardIndex: number; isReversed: boolean } {
  // Create unique seed from user info
  const seed = `${userId ?? 'local'}-${name.toLowerCase()}-${year}-tarot`

  // Select card (0-21 for Major Arcana)
  const cardRandom = seededRandom(seed)
  const cardIndex = Math.floor(cardRandom * 22)

  // Determine if reversed (50/50 chance)
  const reversedRandom = seededRandom(seed + '-reversed')
  const isReversed = reversedRandom >= 0.5

  return { cardIndex, isReversed }
}
